import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import ChatRoom from "./ChatRoom";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [activeChatRoom, setActiveChatRoom] = useState(null);

  useEffect(() => { fetchPrograms(); }, []);

  const fetchPrograms = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "programs"), orderBy("createdAt", "desc"));
      const snap = await getDocs(q);
      setPrograms(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch {
      try {
        const snap = await getDocs(collection(db, "programs"));
        setPrograms(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)));
      } catch {}
    }
    setLoading(false);
  };

  if (activeChatRoom) {
    return <ChatRoom roomId={activeChatRoom.id} roomName={activeChatRoom.title} onBack={() => setActiveChatRoom(null)} />;
  }

  const filtered = programs.filter(p => filter === "all" || p.status === filter);

  return (
    <div>
      <div style={S.headerBox}>
        <h2 style={S.title}>Programs</h2>
        <p style={S.subtitle}>Sanstha ke events aur activities</p>
      </div>

      <div style={S.filterRow}>
        {[{ id: "all", label: "Sab" }, { id: "upcoming", label: "Upcoming" }, { id: "completed", label: "Completed" }].map(f => (
          <button key={f.id} onClick={() => setFilter(f.id)}
            style={{ ...S.filterBtn, background: filter === f.id ? "#0D1B3E" : "#fff", color: filter === f.id ? "#fff" : "#0D1B3E" }}>
            {f.label}
          </button>
        ))}
      </div>

      {loading && <p style={S.empty}>Loading...</p>}
      {!loading && filtered.length === 0 && <p style={S.empty}>Koi program nahi hai abhi.</p>}

      {filtered.map(p => (
        <div key={p.id} style={S.card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <p style={S.cardTitle}>{p.title}</p>
              <p style={S.cardMeta}>{p.date}{p.location ? ` · ${p.location}` : ""}</p>
              {p.desc && <p style={S.cardDesc}>{p.desc}</p>}
            </div>
            <span style={{ ...S.statusBadge, color: p.status === "upcoming" ? "#D97706" : "#16A34A" }}>
              {p.status === "upcoming" ? "Upcoming" : "Completed"}
            </span>
          </div>
          <button onClick={() => setActiveChatRoom({ id: p.id, title: p.title })} style={S.chatBtn}>
            Group Chat Kholo
          </button>
        </div>
      ))}
    </div>
  );
}

const S = {
  headerBox: { marginBottom: 16 },
  title: { margin: "0 0 4px", fontSize: 19, fontWeight: 700, color: "#0D1B3E" },
  subtitle: { margin: 0, fontSize: 13, color: "#9CA3AF" },
  filterRow: { display: "flex", gap: 8, marginBottom: 16 },
  filterBtn: { flex: 1, padding: "9px 12px", border: "1px solid #ECECEE", borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: "pointer" },
  empty: { textAlign: "center", color: "#9CA3AF", fontSize: 13, padding: 40 },
  card: { background: "#fff", border: "1px solid #ECECEE", borderRadius: 14, padding: 16, marginBottom: 10 },
  cardTitle: { margin: "0 0 4px", fontSize: 14, fontWeight: 600, color: "#0D1B3E" },
  cardMeta: { margin: "0 0 6px", fontSize: 12, color: "#9CA3AF" },
  cardDesc: { margin: "0 0 10px", fontSize: 12, color: "#6B7280" },
  statusBadge: { fontSize: 11, fontWeight: 600 },
  chatBtn: { width: "100%", padding: 10, background: "#F7F7F9", color: "#0D1B3E", border: "none", borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: "pointer", marginTop: 8 },
};